import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
// import moment from 'moment-timezone';

//- Material UI / Style
import { withStyles } from '@material-ui/core/styles';

//containers
import AuthUserContainer from '../../../containers/AuthUser';
import PtoRequestContainer from '../../../containers/PtoRequest';

//- UI / Form
import Grid from '@material-ui/core/Grid';
import FormContainer from '../../../components/FormContainer';
import FormComponent from '../../../components/FormComponent';
import { getGlobalClasses } from '../../../themes';
import Note from '../../../components/Note';
import ViewBody from '../ViewBody';
import RequestActivity from '../RequestActivity';

const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
		deleteButton: {
			verticalAlign: 'middle',
			padding: '8px 10px',
		},
		addGroupButton: {
			borderRadius: '100px',
			fontSize: 16,
		},
		groupContainer: {
			borderLeft: '4px solid #ddd',
			marginLeft: 10,
			paddingLeft: 5,
			marginBottom: 20,
		},
		totalSection: {
			fontSize: 26,
			padding: 20,
			border: '1px solid #3faff5',
			margin: 10,
		},
		updateTotalSection: {
			fontSize: 20,
			border: '1px solid #3faff5',
			padding: 20,
			margin: 10,
		},
		addButton: {
			//verticalAlign : 'middle',
			//textDecoration: 'none',
			//marginBottom: 0,
			//borderRadius: 100,
			color: 'white',
			marginRight: 10,
			marginTop: 30,
			fontSize: 18,
			borderRadius: '100px',
			padding: '20px 60px',
			textTransform: 'uppercase',
		},
		cancelButton: {
			marginRight: 10,
			marginTop: 30,
			fontSize: 18,
			borderRadius: '100px',
			padding: '20px 60px',
			textTransform: 'uppercase',
		},
		currentStatus: {},
		statusRow: {
			padding: 7,
		},
	};
};

const idField = 'ptoRequestId';

class SavePtoRequest extends FormComponent {
	constructor(props) {
		super(props);

		const action = _.get(this.props, 'match.params.action');
		const id = parseInt(_.get(this.props, `match.params.${idField}`), 10);
		const isUpdate = action === 'update';

		this.requiredPathMap = {};

		// noinspection JSUnresolvedFunction
		this.state = {
			isUpdate,
			[idField]: id,
			formFieldError: {},
			dateAndHours: [
				{
					date: '',
					hours: '',
				},
			],
		};
	}
	componentDidMount() {
		const { ptoRequest, getPtoRequest } = this.props;
		const { ptoRequestId } = this.state;

		if (ptoRequest) {
			this.fillForm({ ptoRequest });
		} else {
			getPtoRequest({
				params: { ptoRequestIds: [ptoRequestId] },
			});
		}
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (_.isUndefined(prevProps.ptoRequest) && !_.isUndefined(this.props.ptoRequest)) {
			this.fillForm();
		}
	}

	fillForm = () => {
		const { ptoRequest } = this.props;
		if (!ptoRequest) {
			return;
		}
		const newState = {};
		['dateAndHours', 'signatureName', 'signatureDate'].forEach((key) => {
			if (_.isNil(ptoRequest[key])) {
				return;
			}
			newState[key] = ptoRequest[key];
		});
		const { paidType } = ptoRequest;
		if (paidType === 'ptoPaid') {
			newState.ptoPaid = 'ptoPaid';
		} else {
			newState.ptoPaid = 'ptoPaidSickPaid';
		}
		this.setState(newState);
	};

	addDateAndHour = () => {
		const ruleName = 'dateAndHours';
		this.setState({
			[ruleName]: this.state[ruleName].concat([
				{
					date: '',
					hours: '',
				},
			]),
		});
	};

	removeDateAndHour = (index) => {
		const ruleName = 'dateAndHours';
		const inputs = this.state[ruleName].slice();
		inputs.splice(index, 1);
		this.setState({ [ruleName]: inputs });
	};

	approvePtoRequest = () => {
		const { updatePtoRequest, ptoRequest } = this.props;
		updatePtoRequest({
			params: {
				ptoRequestId: ptoRequest.ptoRequestId,
				action: 'supervisorApproval',
			},
		});
	};

	denyPtoRequest = () => {
		const { updatePtoRequest, ptoRequest, showErrors } = this.props;
		const { note } = this.state;

		const formFieldError = {};
		_.values(this.requiredPathMap).forEach(({ path, label }) => {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});
		if (!note) {
			formFieldError.note = 'A note is required when denying a PTO request.';
		}

		//- Get all the values and do individual checks
		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(_.values(formFieldError));
			return;
		}

		updatePtoRequest({
			params: {
				ptoRequestId: ptoRequest.ptoRequestId,
				action: 'supervisorDeny',
			},
		});
	};

	cancelPtoRequest = () => {
		const { updatePtoRequest, ptoRequest, showErrors } = this.props;
		const { note } = this.state;

		const formFieldError = {};
		_.values(this.requiredPathMap).forEach(({ path, label }) => {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});
		if (!note) {
			formFieldError.note = 'A note is required when cancelling a PTO request.';
		}

		//- Get all the values and do individual checks
		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(_.values(formFieldError));
			return;
		}

		updatePtoRequest({
			params: {
				ptoRequestId: ptoRequest.ptoRequestId,
				action: 'supervisorCancel',
			},
		});
	};

	renderStatus = () => {
		const { ptoRequest, classes, userMap } = this.props;

		if (!ptoRequest) {
			return;
		}
		const {
			status,
			requestedForUserId,
			assignedToSupervisorUserId,
			assignedToHrUserId,
		} = ptoRequest;

		const requestor = userMap[requestedForUserId] || { firstName: 'Unknown requested.' };
		const supervisor = userMap[assignedToSupervisorUserId] || { firstName: 'Not assigned yet.' };
		const hr = userMap[assignedToHrUserId] || { firstName: 'Not assigned yet.' };

		return (
			<Grid item xs={12}>
				<Note type="info">
					<div className={classes.statusRow}>
						<strong>Requested for:</strong> {requestor.firstName} {requestor.lastName}
					</div>
					<div className={classes.statusRow}>
						<strong>Assigned to Supervisor:</strong> {supervisor.firstName} {supervisor.lastName}
					</div>
					<div className={classes.statusRow}>
						<strong>Assigned to HR:</strong> {hr.firstName} {hr.lastName}
					</div>
					<div className={classes.statusRow}>
						<strong>Current Status:</strong> {_.startCase(status).replace('Hr ', 'HR ')}
					</div>
				</Note>
			</Grid>
		);
	};

	render() {
		const { ptoRequest, userMap } = this.props;
		if (!ptoRequest) {
			return <div>Loading PTO request...</div>;
		}

		return (
			<>
				<FormContainer headline={`PTO Request`}>
					<ViewBody ptoRequest={ptoRequest} userMap={userMap} />

					<Grid item xs={12} style={{ marginTop: 20, marginBottom: 20 }}>
						<Note>
							<strong>Note</strong> : A PTO request can not be updated once submitted. If a change
							needs to be made please contact your supervisor about cancelling this request and then
							submit a new one.
						</Note>
					</Grid>
				</FormContainer>
				<RequestActivity ptoRequest={ptoRequest} userMap={userMap} />
			</>
		);
	}
}

SavePtoRequest.propTypes = {
	getPtoRequest: PropTypes.func.isRequired,
	addPtoRequest: PropTypes.func.isRequired,
	updatePtoRequest: PropTypes.func.isRequired,
	ptoRequest: PropTypes.object,

	showErrors: PropTypes.func.isRequired,
	authUser: PropTypes.object,
	classes: PropTypes.object.isRequired,
};

export default _.flow([withStyles(styles), AuthUserContainer, PtoRequestContainer])(SavePtoRequest);
